import {axiosClient} from '../axios';

export interface NewsletterSubscribeType {
  email: string;
}

export interface NewsletterSubscribeResponseType {
  readonly email: string;
}
export interface NewsletterSubscribeErrorResponseType {
  readonly errors?: {email?: string};
}

export const subscribeToNewsletter = async (
  formData: NewsletterSubscribeType,
): Promise<NewsletterSubscribeResponseType> => {
  const {data} = await axiosClient.post<NewsletterSubscribeResponseType>(
    '/newsletter-subscribe/',
    formData,
  );
  return data;
};
